module.exports = __webpack_public_path__ + "img/ico_help.9b59a638.svg";